import { Category } from "@common/types/category";
import { Entity } from "@common/types/entity";
import { hasSplitCategoryEntityConflict as hasSplitCategoryEntityConflictBase } from "@common/helpers/rules";

interface SplitCategoryEntityRef {
    categoryId?: string;
    entityId?: number;
}

interface HasSplitCategoryEntityConflictParams {
    splits: SplitCategoryEntityRef[];
    categoriesById: Record<string, Category>;
    entitiesById: Map<number, Entity>;
}

export const hasSplitCategoryEntityConflict = ({
    splits,
    categoriesById,
    entitiesById,
}: HasSplitCategoryEntityConflictParams): boolean =>
    hasSplitCategoryEntityConflictBase({
        splits,
        isCategoryPersonal: (categoryId) => {
            const category = categoriesById[categoryId];
            return category ? !category.isBusiness : undefined;
        },
        isEntityBusiness: (entityId) => {
            const entity = entitiesById.get(entityId);
            return entity?.isBusiness;
        },
    });
